module.exports = __webpack_public_path__ + "static/media/logo-nossa-senhora-do-brasil-2 1.38fadcbf.png";